import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import sha from 'sha.js';


@Injectable({
  providedIn: 'root'
})
export class ScrambleUnscrambleService {

  constructor() { }

  public hashstring = "";
  public subhashstring = "";

  pefundApplyInternalFilter(a, b, c) {
  this.hashstring = sha('sha256').update(c).digest('hex');
  this.subhashstring = this.hashstring.substring(0, 32);
  let Cloak = CryptoJS.enc.Utf8.parse(this.subhashstring);

  let aes = CryptoJS.enc.Hex.parse('676c6f62616c616573766563746f7273');

  if (a == "Cloak") {
    if (b != null) {
      var Scramble = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(b), Cloak, {
        keySize: 128 / 8,
        iv: aes,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });

      var result = Scramble.ciphertext.toString(CryptoJS.enc.Base64);
      result = result.split('+').join('-').split('/').join('_');
      return result;
    }
    return null;

  } else if (a == "Unveil") {
    if (b != null) {
      var Unscrambleinput = b.split('-').join('+').split('_').join('/');

      var Unscramble = CryptoJS.AES.decrypt(Unscrambleinput, Cloak, {
        keySize: 128 / 8,
        iv: aes, 
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });

      return Unscramble.toString(CryptoJS.enc.Utf8);
    } else {
      return null;
    }
  }
}
}
